<!-- 提资流程表单H5 -->
<template>
  <div class="flowForm">
    <!-- 表单 -->
    <van-form ref="formData" :readonly="flowStatus">
      <van-field v-model.trim="formData.title" name="title" label="标题" placeholder="标题" maxlength="30" clearable :rules="[{ required: true, message: '请填写标题' }]" />
      <template v-if="flowStatus">
        <van-field v-model="formData.prjName" label="项目名称" placeholder="项目名称" />
        <van-field v-model="formData.prjCode" label="项目编号" placeholder="项目编号" />
        <van-field v-model="formData.operUserName" label="申请人" placeholder="申请人" />
        <van-field v-model="formData.operTime" label="提交时间" placeholder="提交时间" />
      </template>
      <van-field
        readonly
        :is-link="!flowStatus"
        :value="formData.carryInfoSpecialtyName"
        label="提资专业"
        placeholder="提资专业"
        :rules="[{ required: true, message: '请选择提资专业' }]"
        @click="flowStatus ? '' : (showSpecId = true)"
      />
      <van-field
        readonly
        :is-link="!flowStatus"
        :value="formData.fileLocationName"
        label="存放目录"
        placeholder="存放目录"
        :rules="[{ required: true, message: '请选择存放目录' }]"
        @click="openPosition"
      />
      <van-field
        readonly
        :is-link="!flowStatus"
        :value="formData.acceptSpecialtyName"
        label="接收专业"
        placeholder="接收专业"
        :rules="[{ required: true, message: '请选择接收专业' }]"
        @click="flowStatus ? '' : (showAcceptId = true)"
      />
      <van-field readonly :is-link="!flowStatus" :value="formData.prjPlanName" label="关联计划" placeholder="关联计划" @click="openPriPlan" />
      <van-field v-model.trim="formData.content" label="内容" placeholder="内容" type="textarea" maxlength="200" show-word-limit clearable />
      <van-field readonly label="提资文件">
        <template #button>
          <van-button v-if="!flowStatus" size="mini" type="primary" native-type="button" @click="openFileTree">关联文档</van-button>
        </template>
      </van-field>
    </van-form>

    <!-- 专业弹框 -->
    <van-popup v-model="showSpecId" round position="bottom">
      <van-picker v-if="specList?.length" :columns="specList">
        <template #option="option">
          <div class="oneCell" @click="spacConfirm(option)">{{ option.name }}</div>
        </template>
      </van-picker>
      <div v-else class="empty">暂无数据</div>
    </van-popup>
    <!-- 存放目录弹框 -->
    <treePickerH5
      ref="treePicker"
      :multiple="false"
      title="存放目录"
      :localdata="frameTree"
      valueKey="folderId"
      textKey="folderName"
      childrenKey="childList"
      @select-change="positionConfirm"
    />
    <!-- 接收专业弹框 -->
    <van-popup v-model="showAcceptId" round position="bottom">
      <van-checkbox-group v-if="specAcceptList?.length" v-model="selectAccept" @change="acceptConfirm">
        <van-cell-group>
          <van-cell v-for="(item, index) in specAcceptList" :key="item.id" clickable :title="`${item.name}`">
            <template #right-icon>
              <van-checkbox ref="checkboxes" :name="item" />
            </template>
          </van-cell>
        </van-cell-group>
      </van-checkbox-group>
      <div v-else class="empty">暂无数据</div>
    </van-popup>
    <!-- 关联计划弹框 -->
    <van-popup v-model="showPrjPlan" round position="bottom">
      <van-picker v-if="prjPlanList?.length" :columns="prjPlanList">
        <template #option="option">
          <div class="oneCell" @click="priPlanConfirm(option)">{{ option.name }}</div>
        </template>
      </van-picker>
      <div v-else class="empty">暂无数据</div>
    </van-popup>
    <!-- 关联文档弹框 -->
    <treeLazyH5 ref="treeLazyH5" :load="getFileTree" @check-change="fileCheck"></treeLazyH5>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { Notify } from "vant";
import { getApprove } from "@/CommonDP/components/processComponents/flowNewConfig/mapStore.js";
import flowService from "@/CommonDP/service/flow-service";
import approvalService from "@/CommonDP/service/approve-service";
import treePickerH5 from "@/CommonDP/components/treePickerH5";
import workProjectBoardService from "@/CommonDP/service/workProjectBoard-service";
import docService from "@/CommonDP/service/doc-service";
import treeLazyH5 from "@/CommonDP/components/treeLazyH5";

// 初始化表单
function FormData() {
  return {
    title: "",
    carryInfoSpecialty: "",
    carryInfoSpecialtyName: "", // 提资专业
    prjPlanId: "", // 关联计划
    prjPlanName: "",
    prjName: "",
    prjCode: "",
    operUserName: "",
    operTime: "",
    fileLocation: "", // 存放目录
    fileLocationName: "",
    acceptSpecialty: "", // 接收专业
    acceptSpecialtyName: "",
    content: ""
  };
}

export default {
  components: { treePickerH5, treeLazyH5 },
  props: {
    uuid: {
      type: String,
      default: ""
    }, // 唯一标识
    flowDefinitionId: {
      type: String,
      default: ""
    } // 流程版本号。与 flowKey 两者不可同时为空
  },
  data() {
    return {
      formData: new FormData(), // 表单数据
      flowStatus: false,

      showSpecId: false, // 专业选择
      specList: [],
      frameTree: [], // 存放目录
      showAcceptId: false, // 接收专业选择
      specAcceptList: [],
      selectAccept: [],
      showPrjPlan: false, // 关联计划选择
      prjPlanList: []
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId,
      prjInfo: (state) => state.projectMg.prjObj,
      userInfo: (state) => state.user.userInfo
    }),
    // 流程基本信息
    flowInfo() {
      return getApprove(this.uuid)?.getMessage();
    },
    approveInfo() {
      return getApprove(this.uuid);
    },
    prjId() {
      return this.approveInfo.getPrjId() || this.prjInfo.prjId;
    }
  },
  watch: {
    "formData.carryInfoSpecialty"(newValue, oldValue) {
      if (newValue) {
        this.getPlanTaskList();
      } else {
        this.formData.prjPlanId = "";
        this.formData.prjPlanName = "";
        this.prjPlanList = [];
      }
    }
  },
  mounted() {
    this.formData.title = this.userInfo?.name + "发起" + (this.flowInfo.flowName || "流程");
    if (this.prjId) {
      this.getSpecList();
      this.getAcceptSpecList();
    }
  },
  methods: {
    // 接口：用于获取表单数据
    getFormData() {
      // 接口：用于获取表单数据
      return {
        ...this.formData,
        prjId: this.prjId
      };
    },
    // 接口：设置表单数据
    setFormData(formData) {
      this.formData = formData;
      const acceptSpecialty = typeof formData.acceptSpecialty === "string" ? formData.acceptSpecialty.split(",") : formData.acceptSpecialty;
      this.selectAccept = acceptSpecialty;
    },
    // 接口：校验表单数据
    async validateFormData() {
      let flag = null;
      await this.$refs.formData
        .validate()
        .then(() => {
          flag = true; // 验证通过
        })
        .catch(() => {});
      return flag;
    },

    // 重置表单数据
    resetForm() {
      this.formData = new FormData();
      this.formData.title = this.userInfo?.name + "发起" + (this.flowInfo.flowName || "流程");
    },
    // 禁用表单
    disableForm() {
      this.flowStatus = true;
    },

    // 获得专业列表
    async getSpecList() {
      const { data } = await flowService.querySpecList(this.prjId);
      if (data) this.specList = data.flowSpecPoList || [];
    },
    // 确定专业
    spacConfirm(option) {
      if (option) {
        this.formData.carryInfoSpecialty = option.id || "";
        this.formData.carryInfoSpecialtyName = option.name || "";
      }
      this.$emit("change_showStartButtons");
      this.formData.prjPlanId = "";
      this.formData.prjPlanName = "";
      this.$set(this.formData, "fileLocationName", "");
      this.showSpecId = false;
    },

    // 获取存放目录
    async getFrameTree() {
      this.frameTree = [];
      const params = {
        prjId: this.prjId,
        isRead: 1,
        priviAll: 0,
        folderId: "1630981803194",
        noRightClickMenu: true,
        level: 99
      };
      const { data } = await approvalService.docList(params);
      const list = data || [];
      const childList = this.frameTreeFilter(list);
      this.frameTree = [
        {
          folderName: "提资区",
          folderId: "1630981803194",
          childList: childList || []
        }
      ];
    },
    frameTreeFilter(list) {
      return list.filter((item) => {
        if (item.childList !== null) {
          item.childList = this.frameTreeFilter(item.childList);
        }
        return item.isFolder === 1 && (item.specId === "0" || this.formData.carryInfoSpecialty === item.specId);
      });
    },
    // 打开存放目录弹框
    openPosition() {
      if (this.flowStatus) return;
      if (!this.formData.carryInfoSpecialty) {
        return Notify({ type: "warning", message: "请先选择专业" });
      }
      this.getFrameTree();
      this.$refs.treePicker._show();
    },
    // 确定存放目录
    positionConfirm(list) {
      if (list?.length) {
        const lastFolder = list[0]?.node || {};
        const { folderId, isReadOnly } = lastFolder;
        if (folderId === "1630981803194") return Notify({ type: "warning", message: "请选择提资区下面的文件作为存放目录" });
        if (isReadOnly) return Notify({ type: "warning", message: "系统文件夹非最底级不可存放文件，请重新选择" });
        this.setFileLocation(folderId);
      }
    },
    // 设置存放目录
    async setFileLocation(lastfolderId) {
      const { data } = await workProjectBoardService.getAssociatedFolderLocation(lastfolderId);
      this.$set(this.formData, "fileLocationName", "");
      if (data) {
        this.formData.fileLocationName = data.map(({ folderName }) => folderName).join("\\");
        this.formData.fileLocation = lastfolderId;
        this.frameTree = [];
      }
    },

    // 获得接收专业列表
    async getAcceptSpecList() {
      const { data } = await flowService.queryPrjAcceptSpecialtyList(this.prjId);
      this.specAcceptList = data || [];
    },
    // 确定接收专业
    acceptConfirm(list) {
      this.formData.acceptSpecialty = list.map((item) => item.id)?.join();
      this.formData.acceptSpecialtyName = list.map((item) => item.name)?.join();
    },

    // 获得关联计划列表
    async getPlanTaskList() {
      const carryInfoSpecialty = this.formData?.carryInfoSpecialty || "";
      const flowTempId = this.flowDefinitionId || this.formData?.flowDefinitionId;
      const { data } = await flowService.prjPlanTaskFlowList(flowTempId, carryInfoSpecialty, this.prjId);
      if (data) this.prjPlanList = data || [];
    },
    // 打开关联计划弹框
    openPriPlan() {
      if (this.flowStatus) return;
      if (!this.formData.carryInfoSpecialty) {
        return Notify({ type: "warning", message: "请先选择专业" });
      }
      this.showPrjPlan = true;
    },
    // 确定关联计划
    priPlanConfirm(option) {
      if (option) {
        this.formData.prjPlanId = option.id || "";
        this.formData.prjPlanName = option.name || "";
      }
      this.showPrjPlan = false;
    },

    // 打开关联文档弹框
    openFileTree() {
      if (!this.formData.carryInfoSpecialty) {
        return Notify({ type: "warning", message: "请先选择专业" });
      }
      this.$refs.treeLazyH5.showPopup = true;
    },
    // 懒加载方法
    async getFileTree(node, resolve) {
      const { carryInfoSpecialty } = this.formData;
      if (node.level === 0) {
        const params = {
          folderId: 0,
          isRead: 1,
          priviAll: "1",
          noRightClickMenu: true,
          prjId: this.prjId
        };
        const result = await docService.queryTree(params);
        const list = result.data.filter(({ folderType }) => folderType === 101); // 设计区
        const array = list.map((item) => {
          const { childFolder = 0 } = item;
          return {
            isRead: item.isRead,
            priviAll: item.priviAll,
            folderName: item.folderName,
            folderId: item.folderId,
            isFolder: item.isFolder,
            fileType: item.fileType,
            fileVersion: item.fileVersion,
            status: item.status,
            uploadType: 2,
            leaf: childFolder === 0
          };
        });
        this.$nextTick(() => {
          node.childNodes[0].expanded = true;
          node.childNodes[0].loadData();
        });
        return resolve(array);
      } else if (node.level !== undefined) {
        const params = {
          folderId: node.data.folderId,
          isRead: node.data.isRead,
          priviAll: node.data.priviAll,
          noRightClickMenu: true,
          prjId: this.prjId
        };
        const res = await docService.queryTree(params);
        const speceList = res.data.filter(({ specId }) => specId === "0" || carryInfoSpecialty === specId); // 过滤校审专业
        const listArray = speceList.map((item) => {
          const { childFolder = 0 } = item;
          return {
            isRead: item.isRead,
            priviAll: item.priviAll,
            folderName: item.folderName,
            folderId: item.folderId,
            isFolder: item.isFolder,
            fileType: item.fileType,
            fileVersion: item.fileVersion,
            status: item.status,
            leaf: childFolder === 0,
            uploadType: 2
          };
        });
        return resolve(listArray);
      }
    },
    // 设置选中的文件
    async fileCheck(checkList) {
      const list = [];
      // 对于直接选择文件可以先拿出来
      const array = checkList.filter(({ isFolder }) => isFolder === 0);
      const arrayFolder = checkList.filter(({ isFolder }) => isFolder !== 0);
      const array11 = array.map((item) => {
        return {
          fileName: item.folderName,
          fileId: item.folderId,
          fileType: item.fileType,
          isFolder: item.isFolder,
          status: item.status,
          versionIds: item.fileVersion,
          uploadType: 2
        };
      });
      // 选中的文件夹点击确定获取子级数据
      for (const item of arrayFolder) {
        const params = {
          folderId: item.folderId,
          isRead: item.isRead,
          priviAll: item.priviAll,
          noRightClickMenu: true,
          prjId: this.prjId
        };
        await docService.queryTree(params).then(({ data }) => {
          const listData = data.map((item) => {
            return {
              fileName: item.folderName,
              fileId: item.folderId,
              fileType: item.fileType,
              isFolder: item.isFolder,
              status: item.status,
              versionIds: item.fileVersion,
              uploadType: 2
            };
          });
          list.push.apply(list, listData);
        });
      }
      // 将获取到的非文件过滤掉
      const listLocal = list.filter(({ isFolder }) => isFolder === 0);
      // 拼接原来选择的文件
      const floderDatanew = array11.concat(listLocal);
      // 过滤一下重复的
      const res = new Map();
      const floderData = floderDatanew.filter((a) => !res.has(a.fileName) && res.set(a.fileName, 1));
      this.$emit("tableshow", floderData || []);
    }
  }
};
</script>

<style lang="scss" scoped>
.flowForm {
  width: 100%;
}

.oneCell {
  height: 34px;
  line-height: 34px;
  padding: 0 20px;
  color: #606266;
  font-size: 14px;
}

.empty {
  height: 200px;
  line-height: 200px;
  text-align: center;
  color: var(--info-color);
  font-size: 16px;
}
</style>
